import { EditIcon, IconSize, IconWrapper, Link, StyledFlex } from '@dreryk/react-components';
import { useTranslate } from '@dreryk/react-common';

import { patientPhoneNotificationTranslationKeys } from '../../../translations';

import { PatientPhoneNotificationVideoConsultationReminderConfigurationModalOpener } from './patientPhoneNotificationVideoConsultationReminderConfiguration/PatientPhoneNotificationVideoConsultationReminderConfigurationModal.opener';
import { PatientPhoneNotificationVideoConsultationReminderToggle } from './PatientPhoneNotificationVideoConsultationReminderToggle';
import { PatientPhoneNotificationVideoConsultationReminderToggleLoader } from './PatientPhoneNotificationVideoConsultationReminderToggle.loader';
import { StyledText } from './PatientPhoneNotificationVideoConsultationReminder.styled';
import { PatientPhoneNotificationVideoConsultationReminderConfigurationModalLoader } from './patientPhoneNotificationVideoConsultationReminderConfiguration/PatientPhoneNotificationVideoConsultationReminderConfigurationModal.loader';
import { getAdditionalInformation } from './PatientPhoneNotificationVideoConsultationReminder.utils';

const t = patientPhoneNotificationTranslationKeys;

export const PatientPhoneNotificationVideoConsultationReminder = (): JSX.Element => {
   const translate = useTranslate();

   return (
      <PatientPhoneNotificationVideoConsultationReminderToggleLoader>
         {({ messages, notificationEnabled }) => (
            <StyledFlex direction={'column'} gap={'4px'}>
               <PatientPhoneNotificationVideoConsultationReminderToggle
                  notificationEnabled={notificationEnabled}
                  messages={messages}
               />

               {notificationEnabled ? (
                  <PatientPhoneNotificationVideoConsultationReminderConfigurationModalLoader>
                     {({ videoConsultationNotificationConfiguration }) => (
                        <StyledFlex gap={'10px'} alignItems={'center'}>
                           <StyledText
                              testId={'patientPhoneNotificationVideoConsultationReminderAdditionalInformation'}
                           >
                              {getAdditionalInformation(videoConsultationNotificationConfiguration, translate)}
                           </StyledText>

                           <PatientPhoneNotificationVideoConsultationReminderConfigurationModalOpener
                              videoConsultationNotificationConfiguration={videoConsultationNotificationConfiguration}
                           >
                              {({ openModal }) => (
                                 <Link
                                    onClick={openModal}
                                    testId={'updateVideoConsultationConfiguration'}
                                    label={t.videoConsultationConfiguration.update}
                                    icon={
                                       <IconWrapper testId={'edit'} size={IconSize.SMALL}>
                                          <EditIcon />
                                       </IconWrapper>
                                    }
                                 />
                              )}
                           </PatientPhoneNotificationVideoConsultationReminderConfigurationModalOpener>
                        </StyledFlex>
                     )}
                  </PatientPhoneNotificationVideoConsultationReminderConfigurationModalLoader>
               ) : null}
            </StyledFlex>
         )}
      </PatientPhoneNotificationVideoConsultationReminderToggleLoader>
   );
};
